<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" :width="width" :height="height" viewBox="0 0 300.000000 300.000000" preserveAspectRatio="xMidYMid meet">
    <g xmlns="http://www.w3.org/2000/svg" transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" :fill="iconColor" stroke="none">
      <path d="M680 2834 c-154 -40 -305 -162 -369 -297 -107 -225 -65 -475 108 -648 103 -103 255 -169 391 -169 173 0 356 95 457 237 68 96 103 204 103 323 0 169 -50 291 -164 405 -140 139 -345 197 -526 149z m262 -264 c108 -51 169 -141 176 -261 6 -102 -14 -162 -79 -233 -64 -70 -129 -100 -225 -100 -206 -1 -358 198 -300 395 53 184 259 279 428 199z"/>
      <path d="M2590 2719 c-29 -6 -221 -195 -1175 -1154 -846 -851 -1144 -1156 -1154 -1184 -18 -48 -9 -85 34 -128 27 -27 40 -33 76 -33 24 1 53 6 65 13 11 7 531 525 1156 1153 886 890 1138 1148 1147 1177 30 91 -52 177 -149 156z"/>
      <path d="M2056 1204 c-193 -47 -355 -203 -412 -399 -23 -80 -23 -220 0 -300 58 -199 227 -359 423 -400 350 -75 677 191 677 550 0 362 -340 633 -688 549z m258 -263 c69 -34 113 -78 148 -148 27 -56 32 -77 32 -138 0 -175 -134 -310 -309 -310 -54 0 -82 6 -126 26 -269 126 -233 515 56 590 47 13 154 2 199 -20z"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "IconFee",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
